import { EventSeriesData } from '@beat-venues/common-types';
import { create } from 'zustand';

interface StoryState {
    stories: EventSeriesData[];
    setStories: (stories: EventSeriesData[]) => void;
}

export const useStoryStore = create<StoryState>((set) => ({
    stories: [],
    setStories: (stories) => set({ stories }),
}));
